import { injectGlobal } from 'styled-components'
import { secondaryColor, hoverColor } from './globalTheme'

injectGlobal`
  * {
    outline: none;
  }
  
  *, ::after, ::before {
    box-sizing: border-box;
  }
  
  html,
  body {
    margin: 0;
    padding: 0;
  }

  body {
    height: 100vh;
    overflow-x: hidden;
    color: ${secondaryColor};
    font-family: 'Montserrat', sans-serif;
    line-height: 1.618;
    -webkit-font-smoothing: antialiased;
    font-size: 14px;
    font-weight: 400;
  }
  
  body > #root {
    display: flex;
    min-height: 100vh;
    width: 100%;
    height: 100%;
    flex-flow: wrap row;
  }
  
  a {
    color: ${secondaryColor};
    text-decoration: none;
    background-color: transparent;
    -webkit-text-decoration-skip: objects;
    
    &:hover {
      color: ${hoverColor};
      cursor: pointer;
    }
  }
  
  h1, h2, h3, h4, h5, h6 {
    font-family: 'Montserrat', sans-serif;
    line-height: 1.382;
    margin: 0 0 10px;
    color: ${secondaryColor};
    font-weight: 400;
  }
  
  .react-resizable {
    float: left;
  }
  
  ul li,
  li {
    list-style: none;
  }
`



// WEBPACK FOOTER //
// ./src/theme/globalStyles.js